import { ReactElement, useEffect, useState } from 'react'
import styled from 'styled-components'
import TableInfinite from 'components/table/infinite/InfiniteTable'
import { ITableInfinite } from 'components/table/infinite/InfiniteTable.interfaces'
import { Link, NavigateFunction, useNavigate } from 'react-router-dom'
import { pages } from 'navigation/pages'
import { ApiArtizenBO } from 'utils/artizenConnector'
import { ArtizenUserClass } from '@Arti-zen/package-backoffice/dist/classes/artizenUser'

const definitionFields = (navigate: NavigateFunction): ITableInfinite<ArtizenUserClass>['definitionFields'] => {
  return [
    {
      indexName: 'id',
      label: 'Id',
      format: ({ id }) => (
        <Link to={pages.connected.artisan.profile.navigate(id)} target="_blank">
          {id}
        </Link>
      ),
    },
    {
      indexName: 'lastName',
      label: 'Nom',
      onClick: ({ id }) => {
        navigate(pages.connected.artisan.profile.navigate(id))
      },
    },
    {
      indexName: 'firstName',
      label: 'Prenom',
      onClick: ({ id }) => {
        navigate(pages.connected.artisan.profile.navigate(id))
      },
    },
    {
      indexName: 'companyName',
      label: 'Nom entreprise',
      onClick: ({ id }) => {
        navigate(pages.connected.artisan.profile.navigate(id))
      },
    },
    {
      indexName: 'email',
      label: 'Email',
      onClick: ({ id }) => {
        navigate(pages.connected.artisan.profile.navigate(id))
      },
    },
    {
      indexName: 'isSubscribed',
      label: 'Abonné',
      format: ({ isSubscribed }) => (isSubscribed ? 'oui' : 'non'),
      onClick: ({ id }) => {
        navigate(pages.connected.artisan.profile.navigate(id))
      },
    },
    {
      indexName: 'subscriptionDate',
      label: 'Date abonnement',
      format: ({ subscriptionDate }) => (subscriptionDate ? new Date(subscriptionDate).toLocaleDateString() : ''),
      onClick: ({ id }) => {
        navigate(pages.connected.artisan.profile.navigate(id))
      },
    },
  ]
}

export default function SubAccountNotSyncWithBossAccountDemo(): ReactElement {
  const navigate = useNavigate()

  document.title = 'SubAccountNotSyncWithBossAccountDemo'

  const fields = definitionFields(navigate)

  const [isLoading, setIsLoading] = useState(false)
  const [data, setData] = useState<ArtizenUserClass[]>([])
  const [displayedFields, setDisplayedFields] = useState<(keyof ArtizenUserClass)[]>(fields.map((def) => def.indexName))

  useEffect(() => {
    let isMounted = true
    setIsLoading(true)
    setData([])
    ApiArtizenBO.artizenUsers
      .get()
      .then((artisans) => {
        const bossAccountList = artisans.filter((artisan) => {
          return !artisan.parentId
        })

        const subAccountList = artisans.filter((artisan) => {
          return artisan.parentId
        })

        const filteredArtisans = subAccountList.filter((artisan) => {
          const bossAccount = bossAccountList.find((bossAccount) => {
            return bossAccount.id === artisan.parentId
          })


          return !bossAccount || bossAccount.demoAccount !== artisan.demoAccount
        })

        isMounted && setData(filteredArtisans)
      })
      .finally(() => {
        isMounted && setIsLoading(false)
      })

    return () => {
      isMounted = false
    }
  }, [])

  return (
    <Wrapper>
      <div style={{ width: '80%', marginBottom: 20, textAlign: 'center' }}>
        Liste de tous les comptes salariés qui n'ont pas le même statut DEMO que leur patron
      </div>

      <TableInfinite<ArtizenUserClass>
        displayedFields={displayedFields}
        setDisplayedFields={setDisplayedFields}
        definitionFields={fields}
        data={data}
        nextPage={() => {}}
        isQueriedAllCompleted={true}
        firstColumn={{
          format: () => <></>,
        }}
        isLoading={isLoading}
      />
    </Wrapper>
  )
}

const Wrapper = styled.div`
  display: flex;
  flex: 1;
  flex-direction: column;
  width: 100%;
  justify-content: center;
  align-items: center;
`
